(ns common.schema.entities.decision-ic-exit
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision :as decision]
   [common.schema.entities.decision-options :as decision-options]))

(def schema
  (concat
   decision/schema

   (su/keyword-field :decision/ic-approves-proposed-exit
                     "Investment committee approves proposed exit and sends it to the AIFM"
                     decision-options/ic-approval-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/ic-approves-proposed-exit-notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :decision/conditions
                       "Conditions"
                       [:entity.type/decision-condition]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/text-multiline-field :decision/notes
                            "Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision/date
    #_:decision/fund-has-sufficient-capacity
    #_:decision/complies-with-investment-strategy
    :decision/ic-approves-proposed-exit})
